export default import.meta.ROLLDOWN_FILE_URL_6igaGARiwlftcQdq_GddPw